/**
 * Clears residual body/html locks left by Chakra v3 (Ark/Zag) Dialog when
 * modal effects fail to clean up — typically after force-unmount, key remount,
 * or content torn down while the machine is still open.
 *
 * Zag modal dialogs can leave behind:
 * - body pointer-events: none + data-inert (dismissable pointer-blocking)
 * - sibling inert / data-inerted (hideContentBelow)
 * - aria-hidden / data-aria-hidden (fallback when inert unsupported)
 * - data-scroll-lock + overflow/position styles (preventBodyScroll)
 */
export function clearDialogBodyLocks() {
  if (typeof document === 'undefined') {
    return
  }

  document.querySelectorAll('[data-inerted]').forEach(el => {
    el.removeAttribute('inert')
    el.removeAttribute('data-inerted')
  })

  document.querySelectorAll('[data-aria-hidden]').forEach(el => {
    el.removeAttribute('aria-hidden')
    el.removeAttribute('data-aria-hidden')
  })

  const body = document.body
  const html = document.documentElement

  body.removeAttribute('data-scroll-lock')
  body.removeAttribute('data-inert')
  body.style.removeProperty('overflow')
  body.style.removeProperty('position')
  body.style.removeProperty('top')
  body.style.removeProperty('left')
  body.style.removeProperty('right')
  body.style.removeProperty('padding-right')
  body.style.removeProperty('padding-left')
  body.style.removeProperty('pointer-events')
  if (body.style.length === 0) {
    body.removeAttribute('style')
  }

  html.style.removeProperty('--scrollbar-width')
  html.style.removeProperty('overflow')
  html.style.removeProperty('pointer-events')
  if (html.style.length === 0) {
    html.removeAttribute('style')
  }
}
